import { render, staticRenderFns } from "./VehicleModel.vue?vue&type=template&id=701b3ecc"
import script from "./VehicleModel.vue?vue&type=script&lang=js"
export * from "./VehicleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701b3ecc')) {
      api.createRecord('701b3ecc', component.options)
    } else {
      api.reload('701b3ecc', component.options)
    }
    module.hot.accept("./VehicleModel.vue?vue&type=template&id=701b3ecc", function () {
      api.rerender('701b3ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleModel.vue"
export default component.exports